import type { OutboundRuleFormData, SubnetConfigMode, TagPair } from "../../../../helpers/cloudPropagationHelpers";

export const SUBNET_CONFIG_MODE_LABELS: Record<SubnetConfigMode, string> = {
  manual: "Manual selection",
  subnet_tags: "Subnet tags",
  routing_table: "Routing table",
};

export function defaultTagPair(): TagPair {
  return { tagName: "", tagValue: "" };
}

export function defaultOutboundRule(): OutboundRuleFormData {
  return {
    outboundId: null,
    name: "",
    selectedVpc: "",
    subnetConfigMode: "manual",
    subnets: [],
    subnetTags: [defaultTagPair()],
    routingTableTags: [defaultTagPair()],
    filterSubnetsInRoutingTables: false,
    subnetFilterTags: [defaultTagPair()],
    bgpCommunity: "",
    nexthopIPAddress: "",
    expanded: true,
  };
}

export function duplicateOutboundRule(rule: OutboundRuleFormData): OutboundRuleFormData {
  return {
    ...rule,
    outboundId: null,
    subnets: [...(rule.subnets || [])],
    subnetTags: (rule.subnetTags || []).map((t) => ({ ...t })),
    routingTableTags: (rule.routingTableTags || []).map((t) => ({ ...t })),
    subnetFilterTags: (rule.subnetFilterTags || []).map((t) => ({ ...t })),
    expanded: true,
  };
}

export function getOutboundRuleSummary(
  rule: OutboundRuleFormData,
  vpcOptions: Array<{ value: string; label: string }>
): string {
  const vpcLabel =
    vpcOptions.find((o) => o.value === rule.selectedVpc)?.label ||
    rule.selectedVpc ||
    "No VPC";
  const modeLabel = SUBNET_CONFIG_MODE_LABELS[rule.subnetConfigMode] || "Manual selection";
  return `${vpcLabel} · ${modeLabel}`;
}
